
export default {
  props: {
    variant: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'pill', 'text'].includes(value)
      },
    },
    target: {
      type: String,
      default: '_blank',
    },
    href: {
      type: String,
      required: true,
    },
    arrowLeft: {
      type: Boolean,
      default: false,
    },
    arrowRight: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classObject() {
      return {
        'pointer-events-none': this.disabled,
        'rounded-full max-w-[20rem] h-8 sm:px-7 flex justify-center items-center pt-[2px]':
          this.variant === 'pill',
        'max-w-[20rem] flex justify-start items-center pt-[2px]':
          this.variant === 'text',
        '': this.variant === 'default',
      }
    },
  },
}
